import Units from "../../../utils/Units";

let gridColor = "rgba(0, 0, 0, 0.1)";
let tickFontSize = 10;
let Kmh = {
    id: "kmh",
    gridLines: {
        color: gridColor,
        zeroLineColor: "rgba(0, 0, 0, 0)"
    },
    ticks: {
        fontSize: tickFontSize,
        maxTicksLimit: 10,

        callback: (value, index, values) => {
            return "  " + Units.rounded(value,2) + "";
        }
    }
};

export default Kmh;



// WEBPACK FOOTER //
// ./src/components/chart/axes/Kmh.js